export const transRu = {
    myLocal: {
        columns: 'Колонки',
        hide_filter: 'Скрыть фильтр',
        show_filter: 'Показать фильтр',
    },
    dbFields: {},

   "To download the order file, you must first stop the order unloading to the accounting system.": "Для скачивания файла с заказом необходимо сначала остановить выгрузку заказа в учетную систему.",
   "Enter the text that will appear when hovering over the INFO icon on the pool card in the filter interface.": 'Укажите текст, который будет отображаться при наведении на иконку ИНФО на карточке бассейна в интерфейсе фильтра.',
   'Filter (pool)': 'Фильтр (бассейн)',

   "Cancel": "Отменить",
   "Confirmed": "Подтвердить",
   "Are you sure you want to stop unloading to the accounting system?": "Вы уверены, что хотите остановить выгрузку заказа в учетную систему?",
   "Are you sure you want to resume unloadingto the accounting system?": "Вы уверены, что хотите возобновить выгрузку заказа в учетную систему?",
   "Stop unloading": "Остановить выгрузку",
   "Resume unloading": "Возобновить выгрузку",

   "Create address": "Создание адреса",
   "Creating a delivery address for partner": "Создание адреса доставки для партнёра",
   "Request No": "Заявка №",

   "Filled": "Заполнено",
   "Not filled": "Не заполнено",
   "Update counterparty properties": "Обновить свойства контрагентов",
   "Update Main Warehouse": "Обновить Основной склад",
   "Update Pickup Warehouses": "Обновить Склады самовывоза",
   "Update Exception Warehouses": "Обновить Склады-исключения",
   "Update TP Info and Managers": "Обновить инфо ТП и Менеджеры",

   "Source": "Источник",
   "Warehouse": "Склад",
   "Invoice": "Накладная",
   "Article": "Артикул",
   "Orders": "Заказы",
    "Amount": "Сумма",
    "Initial amount": "Сумма начальная",
    "Current amount": "Сумма текущая",
    "Quantity: current (initial)": "Кол-во: текущее (начальное)",

    '--- None ---': '--- Не заполнено ---',
    'Add / Delete Categories': 'Добавить / Удалить Категории',
    'Add Categories': 'Добавить категории',
    'Delete Categories': 'Удалить категории',
    'File selected': 'Выбран файл',
    'Export to Excell': 'Выгрузить в Excell',
    'Import from Excell': 'Загрузить мз Excell',
    'Uploading file': 'Загрузка файла',
    'Field of activity': 'Направление деятельности',
    'Property of belonging to a region': 'Свойство принадлежности к региону',
    'Select filters (optional)': 'Выберите фильтры (опционально)',
    'Unloading counterparties': 'Выгрузка контрагентов',
    'Loading counterparties': 'Загрузка контрагентов',
    'Unloading selected counterparties': 'Выгрузка выбранных контрагентов',

    'Available warehouses for pickup': 'Доступные склады для самовывоза',
    'Available warehouses for pickup (comment)': 'Склады, перечисленные в данном поле, будут доступны при выборе типа доставки «Самовывоз». Основной склад контрагента по умолчанию доступен для самовывоза, поэтому его не обязательно указывать в этом поле.',
    'Excluded warehouses': 'Склады-исключения',
    'Excluded warehouses (comment)': 'Если для контрагента нужно скрыть (исключить) некоторые склады, укажите их в этом поле. Эти склады не будут отображаться в результатах поиска и в корзине. Остальные склады будут доступны.',

    'error type delivery': 'Для одного адреса партнера можно добавить только маршруты доставки с одинаковым типом доставки. Пожалуйста, убедитесь, что все выбранные маршруты имеют один тип доставки.',

    'Loading goods': 'Загрузка товаров',
    'Quantity in file': 'Количество в файле',
    'Not found': 'Не найдено',
    'Validation errors': 'Ошибки валидации',

    'Trade Marks': 'Торговая марка',
    'Page Title': 'Заголовок страницы',
    'Archive': 'Архив',
    'Priority': 'Приоритет',
    'Link to page': 'Ссылка на страницу',
    'Link to catalog in search': 'Ссылка на каталог в поиске',
    "Link to manufacturer's catalog": 'Ссылка на каталог производителя',
    "Manufacturer's website": 'Сайт производителя',
    'Country': 'Страна',
    'Cross code file(csv or xls)': 'Файл кросс-кодов(csv или xls)',

    'Status': 'Статус',
    'Required field': 'Обязательное для заполнения',
    'Badge': 'Бейдж',
    'Promotion Type': 'Тип акции',
    'Promotion type': 'Тип акции',
    'Product Gift': 'Подарочный товар',
    'Fix price currency': 'Валюта фиксированной цены',
    'Sort': 'Сортировать',
    'RGB code': 'RGB код',
    'RGB badge name code': 'RGB код названия бейджа',
    'Promotion Badge': 'Бейдж акции',
    'Promotion': 'Акции',
    'Discount Rule': 'Правило скидки',

    "Code": "Код",

    "Show on creation customer process": "Отображать на форме создания клиента",
    "Partners delivery address": "Адрес доставки партнера",
    "Partners delivery addresses": "Адреса доставки партнера",
    "Select a user from the list": "Выбрать пользователя из списка",
    "Enter new user": "Ввести нового пользователя",
    "Go to client": "Перейти к клиенту",
    "This field already exists": "Такое поле уже существует",
    "Client saved": "Клиент успешно сохранен",
    "Create new client": "Создать нового клиента",
    "Delivery Routes": "Маршруты доставки",
    "Need to specify an address for the counterparty": "Нужно указать адрес для контрагента",
    "Delete": "Удалить",
    "Route": "Маршрут",
    "Routes": "Маршруты",
    "Auto": "Авто.",
    "Create client": "Создать клиента",
    "Partner from list": "Выбрать партнера из списка",
    "New customer": "Новый контрагент",
    "New customers": "Новые контрагенты",
    "New partner": "Создать нового партнера",
    "Create Partner": "Создать партнера",
    "Save": "Сохранить",
    "Accounting phone": "Телефон бухгалтерии",
    "Warehouse phone": "Телефон склада",
    "Accounting email": "Электронная почта бухгалтерии",
    "Partner information": "Информация о партнере",
    "Partner customers": "Контрагенты партнера",
    "Partner address": "Адреса партнера",
    "Delivery": "Доставка",
    "Create partner": "Создать партнера",
    "Create customers": "Создать контрагентов",
    "Customers for partner": "Создание контрагентов для партнера",
    "Add customer": "Добавить еще одного контрагента",
    "Add address": "Добавить еще один адрес",
    "Settings for pricing": "Настройки ценообразования",
    "Common data": "Общие данные",
    "Customer users": "Пользователи контрагента",
    "Back": "Назад",
    "Next": "Далее",
    "Old address": "Ранее добавленные адреса",
    "Address for partner": "Адреса для партнера",
    "Save partners data": "Сохранить данные партнера",
    "Save clients data": "Сохранить данные клиента",
    "New address": "Новый адрес",
    "Select from list": "Выбрать из списка",
    "this value already exists": "такое значение уже существует",

    "Customer property": "Свойства контрагента",

    "Is Active": "Активен",
    "Is Superuser": "Суперпользователь",
    "Is Staff": "Персонал",
    "First Name": "Имя",
    "Middle name": "Отчество",
    "Last Name": "Фамилия",
    "Partner": "Партнер",
    "Partners": "Партнеры",
    "User": "Пользователь",
    "Username": "Имя пользователя",
    "Users": "Пользователи",
    "Create user": "Создать пользователя",
    "Categories": "Категории",
    "Password": "Пароль",
    "Change password": "Изменить пароль",
    "Confirm password": "Подтвердить пароль",
    "The password is required (length > 5)": "Пароль обязателен (длина > 5)",
    "Password confirmation error": "Ошибка подтверждения пароля",
    //-----------------------
    "Phone": "Телефон",
    "Phones": "Телефоны",
    "Official name": "Официальное наименование",
    "Customer name": "Наименование контрагента",
    "Code from the accounting system": "Код из учетной системы",
    "Client code": "Код клиента",
    "Main warehouse": "Основной склад",
    "Legal address": "Юридический адрес",
    "Physical address": "Физический адрес",
    "Credit limit currency": "Валюта кред. лимита",
    "Credit limit term (days)": "Срок кред. лимита (дней)",
    "Credit limit amount": "Сумма кред. лимита",
    "Contractor type": "Тип контрагента",

    "Processed": "Обработано",
    "Client wish": "Пожелание клиента",
    "Business type": "Вид деятельности",
    "Customer requests": "Заявки клиентов",
    "Request type": "Тип заявки",
    "Application closed": "Заявка закрыта",
    "Partner name": "Наименование партнера",
    "Partner phone": "Телефон партнера",
    "Partner email": "Почта партнера",

    "VAT payer": "Плательщик НДС",
    "EDRPOU": "ЕГРПОУ",
    "Tax number": "ИНН",
    "VAT identification number": "Ид. номер НДС",
    "How to show quantity": "Как показывать наличие",
    "Retail margin": "Розничная наценка",
    //-----------------------
    "Manager": "Менеджер",
    "Sales representative SNG": "ТП СНГ",
    "Sales representative Ino": "ТП иномарки",

    "Confirm": "Подтверждено",
    "Disable": "Отключен",
    "Address": "Адрес",
    "Saved Address": "Сохраненный адрес",
    "Address lat / lon": "Адрес lat / lon",
    "Area": "Область",
    "Region": "Район",
    "Point": "Населенный пункт",
    "Street": "Улица",
    "House": "Дом",
    "Flat": "Квартира",
    "Deliveries": "Доставки",
    "Comment": "Комментарий",
    "Placement": "Расположение",
    "Partner Address": "Адрес партнера",

    "Check coordinates on the map": "Проверить координаты на карте",
    "Fill in coordinates manually": "Заполнить координаты вручную ",
    "Functionality under development": "Функционал в разработке",
    "Automatic address filling": "Автоматическое заполнение адреса",
    //-----------------------

    ignore: 'игнорировать',

    "Select file": "Выбрать файл",
    "Download file": "Загрузить файл",
    "Clear": "Очистить",

    "Amount (base price)": "Сумма (базовая цена)",
    "Amount (regular price)": "Сумма (регулярная цена)",
    "Total order including discounts": "Итого заказ с учетом скидок",

    add: 'добавить',
    absorb: 'поглощать',
    absorbed_by: 'поглощен (кем/чем)',
    maximum: 'максимум',
    minimum: 'минимум',

    'Active': 'Активный',
    Additionally: 'Дополнительно',
    'Applied Rule': 'Применяемое правило',
    'Absorbed Rule': 'Заменяемое правило',

    'Base price': 'Базовая цена',
    BONUSES: 'БОНУСЫ',
    Bonuses: 'Бонусы',
    'Bonus': 'Бонус',
    'bonus': 'бонус',
    Brands: 'Бренды',
    Brand: 'Бренд',
    brand_ref: 'Бренд (справочник)',
    Brand_ref: 'Бренд (справочник)',
    BrandsSynonyms: 'Синонимы бренда',
    Brandssynonyms: 'Синонимы бренда',
    BrandsReplacement: 'Замены брендов в прайсах поставщиков',
    Brandsreplacement: 'Замены брендов в прайсах поставщиков',
    BrandImage: 'Изображение бренда',
    Brandimage: 'Изображение бренда',
    brands_country: 'Страна бренда',
    'Brands By Rule': 'Бренды по правилам',

    'complicated_rule': 'сложное правило',
    'customer': 'контрагент',
    'Clear Result': 'Очистить результат',
    COMMON: 'ОБЩИЕ',
    Common: 'Общие',
    Characteristics: 'Характеристики',
    Customers: 'Контрагенты',
    Customer: 'Контрагент',
    CREATED: 'СОЗДАНО',
    Created: 'Создано',
    created: 'создано',
    CREATE: 'СОЗДАНО',
    Create: 'Создано',
    create: 'создано',
    Currencies: 'Валюта',
    Currency: 'Валюта',
    'Customer Property Value': 'Значение Свойств Контрагента',
    'Current Discount Rule': 'Текущее Правило Скидки',
    'Customer Discount By Rule': 'Скидка клиента по правилу',
    'Complicated Discount By Rule': 'Сложная скидка по правилу',

    DESCRIPTION: 'ОПИСАНИЕ',
    description: 'описание',
    Description: 'Описание',
    DiscountCustomerBrand: 'Значение дисконта',
    DiscountcustomerBrand: 'Значение дисконта',
    Discount: 'Скидка',
    "Discount Property": 'Свойства Скидок',
    "Discount property": 'Свойства скидок',
    'Discount Rules': 'Правила Скидок',
    'Discount By Rule': 'Скидка по правилу',
    'Discount Property Value': 'Значение Свойств Скидок',
    'Discount property value': 'Значение свойств скидок',
    'Discount Relationship': 'Отношения Скидок',
    'Discount relationship': 'Отношения скидок',
    'Discount Relation Ship': 'Отношения скидок',
    'Default Discount': 'Скидки по умолчанию',
    'Default Relation': 'Отношение по умолчанию',
    'Date From': 'Дата с',
    'Date To': 'Дата по',

    'Earlier': 'Ранее',
    'Export Customer Properties': 'Экспорт свойств контрагента',

    'For All Products': 'Для Всех Товаров',
    'Fix price': 'Фикс. цена',

    'Go Back': 'Вернуться',

    hidden_for_user: 'скрывать для пользователя',
    'History': 'История',

    massive: 'габаритный',

    'Last Rule': 'Последнее правило',

    // NO: 'НЕТ',
    // YES: 'ДА',
    // No: 'Нет',
    // Yes: 'Да',

    name: 'наименование',
    Name: 'Наименование',

    'Order discounts': 'Скидка на заказ',
    original_brand: 'оригинальный бренд',
    Other: 'Другие',
    'Min.amount of non-prom. item': 'Мин.сумма неакц-го товара',
    'Min.order amount': 'Мин.сумма заказа',
    'Min. amount': 'Мин. сумма',

    'Order Quantity': 'Кол-во (заказ)',
    'order': 'заказ',
    'Order': 'Заказ',

    'Quantity': 'Кол-во',
    'quantity': 'Кол-во',

    Prefixes: 'Префикс',
    'Price with order discounts': 'Цена со скидкой при заказе',
    'PRODUCTS': 'ПРОДУКТЫ',
    Protected: 'Защищено',
    protected: 'защищено',
    Products: 'Товары',
    Product: 'Товар',
    'Products By Rule': 'Товары по правилам',
    'Product Property': 'Свойства Товара',
    'Product Property Value': 'Значения Свойств Товара',
    'Price Currency': 'Валюта Цены',
    'Price': 'Цена',
    'product': 'товар',

    'Price Of Week': 'Цена недели',
    'Price of week': 'Цена недели',

    'Regular discounts': 'Регулярные скидки',
    'Regular price': 'Регулярная цена',
    'Related Table': "Доп. Таблицы",
    "Related table": 'Доп. таблицы',
    'Rule type': 'Тип правила',
    'Rule Type': 'Тип Правила',
    'Rate': 'курс',
    'Relaited Discount Rule': 'Правило Связанных Скидок',
    'Relation': 'Отношение',

    // "Brand_ref": 'Бренд (справочник)',
    Index: "Индекс",
    index: "индекс",
    is_new: 'Новый',
    is_offer: 'Акция',
    is_populate: 'Популярный',
    is_sale: 'Распродажа',

    Specification: 'Спецификация',
    sku: 'ску',
    source: 'источник',
    Suffixes: 'Суфикс',
    'Save & Close': 'Сохранить и выйти',
    'Search': 'Поиск',

    'Test': "Проверка",
    'Test Price': 'Проверка цены',
    'Test Order': 'Проверка заказа',
    Today: 'Сегодня',
    'This week': 'Эта неделя',
    'This month': 'Этот месяц',

    Updated: 'Изменено',
    updated: 'изменено',
    Update: 'Изменено',
    update: 'изменено',
    "Units of Measure": 'Еденицы измерения',
    uuid: 'uuid',

    'PROTECTED RECORDS. Creation of related tables prohibited': 'ЗАЩИЩЕННЫЕ ЗАПИСИ. Создание сопутствующих таблиц запрещено',
    'Editing of related tables will be available after record creation': "Редактирование сопутствующих таблиц буде доступно после создания записи",
    remove_alternate_parent: "Удалить альтернативную связь с %{parent_name}",
    replace_alternate_to_parent: "Сделать %{parent_name} прямым родителем и сделать связь с %{alternate_parent_name} альтернативной",
    replace_parent: "Сделать %{parent_name} прямым родителем и удалить связь с %{alternate_parent_name}",
    remove_parent: "Удалить прямую связь с %{parent_name}",
    make_alternative: "Сделать %{parent_name} альтернативным родителем",
    make_direct: "Сделать %{parent_name} прямым родителем",
    undo_action: 'Отменить действие',
    categories_tree: 'Дерево Категорий',
    edit_category: 'Редактировать категорию',
    show_hidden_categories: 'Показать скрытые для пользователя категории',
    hidden_for_user_category: 'Скрыто',
    show_category_for_user: 'Отобразить категорию для юзера',
    hide_category_for_user: 'Скрыть категорию для юзера',
    mixed: 'Смешанная',
    group_only: 'Только категории',
    item_only: 'Только товары',
    'Hierarchy type': 'Тип иерархии',
    'Hide category and its products': 'Скрыть категорию и ее продукты',
    'Display On Main Page': 'Отображать на главной странице',
    'Display in Header and/or Catalogue tree': 'Отображение в заголовке и/или дереве каталога',
    'Use as Filter in listing': 'Использовать как фильтр в листинге',
    hidden_for_user_description: 'Если установлен признак, категория и ее подкатегории полностью скрываются на сайте. Также будут скрыты все товары, для которых эта категория или любая из ее подкатегорий установлена как родительская. Товары не будут отображаться, включая результаты поиска.',
    show_on_main_description: 'Укажите, должна ли категория отображаться в блоке на главной странице сайта. Обычно это категории, которые продвигаются компанией.',
    show_on_menu_description: 'Укажите, должна ли категория отображаться в меню сайта, включая хедер или дерево категорий, если это предусмотрено дизайном. ',
    show_on_filter_description: 'Укажите, должна ли категория отображаться в фильтрах на странице листинга. Например, при поиске «Фильтры» в фильтрах листинга могут появляться такие категории, как «Воздушные», «Масляные», «Кондиционера».',
    'Display type': 'Тип отображения',
    show_category: 'Отображать категорию',
    hide_category_show_children: 'Не отображать категорию, НО отображать вложенные',
    hide_category_and_children: 'Не отображать категорию и скрыть все вложенные',
    pool_description: 'Описание бассейна'
}

